import { getName } from "i18n-iso-countries";

export const getCountryNameByCode = (countryCode: string, locale = "en"): string => {
  const countryName = getName(countryCode, locale);

  if (!countryName) {
    console.warn(`Country code "${countryCode}" not found for locale "${locale}"`);
    return "-";
  }

  return countryName;
};
